import styled from 'styled-components';
import { useTranslate } from '@agilepoint/wat-react';
import { IChangeArgs, StackPanel } from '@agilepoint/wat-react-ux';
import { TextBoxField } from '@agilepoint/wat-react-ux-form-fields';
import { CustomTooltip, FileUploadField, HorizontalLine } from 'common';
import { PlatformTypes } from '../steps';
import { BuildDetailsFields, RelativePositionedFlexbox } from '../styled-components';
import { getBuildOptions } from './android-build-details-form';

const stopPropagation = (ev: React.MouseEvent<HTMLElement>) => ev.stopPropagation();

const PasswordTextbox = styled(TextBoxField)`
.ap-textbox-wrapper {
    padding:0px;
    .ap-textbox{
        padding:0 16px !important;
    }
}
`;

export const IOSBuildDetailsForm = () => {
    const translate = useTranslate();
    const validateP12File = (value: IChangeArgs) => {
        if (!value.selectedFiles.length) {
            return translate('modules.createNewApp.steps.platform.iosBuildDetails.iosUploadFile');
        }
        else if (!value.selectedFiles[0]?.name.endsWith('.p12')) {
            return translate('modules.createNewApp.steps.platform.iosBuildDetails.uploadP12File');
        }
        return true;
    };
    const validateMobileProvisioningFile = (value: IChangeArgs) => {
        if (!value.selectedFiles.length) {
            return translate('modules.createNewApp.steps.platform.iosBuildDetails.iosUploadFile');
        }
        else if (!value.selectedFiles[0]?.name.endsWith('.mobileprovision')) {
            return translate('modules.createNewApp.steps.platform.iosBuildDetails.uploadMobileProvisionFile');
        }
        return true;
    };
    return (
        <>
            <HorizontalLine $margin='17px 0px 25px 0px !important' />
            <StackPanel onClick={stopPropagation} orientation="vertical" gap="20" width="100%">
                <BuildDetailsFields
                    groupName="ios-build-details"
                    name={`${PlatformTypes.IOS}.buildTypes`}
                    options={getBuildOptions(translate)}
                    orientation="vertical" />
                <RelativePositionedFlexbox width='100%' height='100%'>
                    <FileUploadField
                        name={`${PlatformTypes.IOS}.certificate`}
                        label={translate('modules.createNewApp.steps.platform.certificateLabel')}
                        validationRules={{ required: translate('modules.createNewApp.steps.platform.iosBuildDetails.certificateRequiredText'), validate: validateP12File }}
                        orientation='vertical'
                        accept=".p12"
                        readMode="readAsDataURL" />
                    <CustomTooltip tooltipContent={translate('modules.createNewApp.steps.platform.iosBuildDetails.certificateofAppleDeveloper')} />
                </RelativePositionedFlexbox>
                <PasswordTextbox
                    name={`${PlatformTypes.IOS}.password`}
                    title={translate('modules.createNewApp.steps.platform.iosBuildDetails.passwordLabel')}
                    label={translate('modules.createNewApp.steps.platform.iosBuildDetails.passwordLabel')}
                    validationRules={{ required: translate('modules.createNewApp.steps.platform.iosBuildDetails.passwordRequiredText') }}
                    type="password" />
                <RelativePositionedFlexbox width='100%'>
                    <FileUploadField
                        name={`${PlatformTypes.IOS}.provisioningProfile`}
                        title={translate('modules.createNewApp.steps.platform.iosBuildDetails.provisioningProfileLabel')}
                        label={translate('modules.createNewApp.steps.platform.iosBuildDetails.provisioningProfileLabel')}
                        orientation='vertical'
                        validationRules={{ required: translate('modules.createNewApp.steps.platform.iosBuildDetails.certificateRequiredText'), validate: validateMobileProvisioningFile }}
                        accept=".mobileprovision"
                        readMode="readAsDataURL" />
                    <CustomTooltip tooltipContent={translate('modules.createNewApp.steps.platform.iosBuildDetails.developmentProvisioningProfileHeader')} />
                </RelativePositionedFlexbox>
            </StackPanel>
        </>
    );
};
